module.exports = __webpack_public_path__ + "img/bh3.5dba6dbb.jpeg";